// extracted by mini-css-extract-plugin
module.exports = {"cards-list":"styles_cards-list__oTHwF","no-carousel":"styles_no-carousel__DIE_J","type-3":"styles_type-3__xf6xJ","type-2":"styles_type-2__QYMok"};